import { CloseIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { factory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import { FocusTrap } from '../subcomponents/FocusTrap/FocusTrap.mjs';
import { OptionalPortal } from '../subcomponents/Portal/OptionalPortal.mjs';
import classes from './Modal.module.css.mjs';
import { useModal } from './Modal.utils.mjs';

const Modal = factory((props, ref) => {
  const {
    children,
    opened,
    onClose,
    title,
    zIndex = 100,
    closeOnClickOutside = true,
    className,
    modalContentProps,
    closeButtonProps,
    withinPortal = false,
    portalProps,
    closeCTA,
    ...rest
  } = props;
  const classNames = clsx(className, classes.modalRoot, "kohler-modal-root");
  const { _id } = useModal({
    opened,
    onClose
  });
  if (closeButtonProps) console.warn("Property `closeButtonProps` will be deprecated soon. Please use `closeCTA` instead.");
  const closeButtonAttr = closeCTA ?? closeButtonProps;
  const handleOutsideClick = (e) => {
    if (!closeOnClickOutside) return;
    if (closeCTA?.onClick) {
      closeCTA.onClick(e);
    } else {
      onClose?.();
    }
  };
  return /* @__PURE__ */ React.createElement(OptionalPortal, { ...portalProps, withinPortal }, /* @__PURE__ */ React.createElement(Box, { ...rest, className: classNames, ref, mod: "white" }, opened && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Box,
    {
      className: clsx(classes.modalOverlay, "kohler-modal-overlay"),
      style: { zIndex },
      onClick: (e) => handleOutsideClick(e)
    }
  ), /* @__PURE__ */ React.createElement(Box, { className: classes.modal, style: { zIndex } }, /* @__PURE__ */ React.createElement(FocusTrap, { active: opened }, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "section",
      className: clsx(classes.modalContentWrapper, "kohler-modal-content"),
      role: "dialog",
      "aria-modal": true,
      "aria-label": title,
      "aria-describedby": `${_id}-content`,
      tabIndex: -1,
      ...modalContentProps
    },
    /* @__PURE__ */ React.createElement(
      Box,
      {
        component: "button",
        type: "button",
        "aria-label": "Close modal",
        onClick: onClose,
        ...closeButtonAttr,
        className: clsx(classes.modalCloseIcon, closeButtonAttr?.className)
      },
      /* @__PURE__ */ React.createElement(CloseIcon, { withBoundingBox: false })
    ),
    /* @__PURE__ */ React.createElement(Box, { id: `${_id}-content` }, children)
  ))))));
});

export { Modal };
